import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import style from './Market.module.scss';

import { PRODUCTS } from '../../../constants';

import ZeroIcon from '../../../../images/icons/icon-sport-svg/zero.svg';

export default function Market({
  marketName = '',
  runnerName = '',
  isBetBuilderBet = false,
  betType,
  product = PRODUCTS.exchange,
  eventId
}) {
  const marketNameElement = (
    <span className={style.marketName}>
      {marketName && marketName.toLowerCase()
        .split(' ')
        .map(word => _.capitalize(word))
        .join(' ')}
      {product === PRODUCTS.mbzero && betType !== 'unmatched' && (
        <ZeroIcon />
      )}
    </span>
  );

  let runnerNameElement;

  if (isBetBuilderBet) {
    runnerNameElement = (
      <span className={style.runnerName}>
        Bet Builder
      </span>
    );
  } else {
    runnerNameElement = (
      <Link
        className={style.runnerName}
        to={product === PRODUCTS.mbzero ? `/zero/events/${eventId}` : `/events/${eventId}`}
      >
        {runnerName}
      </Link>
    );
  }

  return (
    <div className={`${style[`marketRow--${betType}`]}`}>
      {!isBetBuilderBet && marketNameElement}
      {runnerNameElement}
    </div>
  );
}

Market.propTypes = {
  betType: PropTypes.string.isRequired,
  marketName: PropTypes.string,
  runnerName: PropTypes.string,
  product: PropTypes.string,
  eventId: PropTypes.string,
  isBetBuilderBet: PropTypes.bool,
};
